import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
@Directive({
  selector: '[OnlyZeroToSixNumber]'
})
export class OnlyZeroToSixNumberDirective {
  constructor(private el: ElementRef ,private ngControl: NgControl) {}

  @HostListener('input', ['$event']) onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Allow only numbers from 0 to 6
    if (!/^[0-6]$/.test(value)) {
      value = value.replace(/[^0-6]/g, ''); // Remove invalid characters
    }

    // Ensure only one character is present
    if (value.length > 1) {
      value = value.charAt(value.length - 1); // Keep only the last entered character
    }

    // Update the view and model
    input.value = value;
    this.ngControl.control?.setValue(value);
  }
}
